import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { IShopperStaffDiscountTransactionsSummary } from '../../../../model/IShopperStaffDiscountTransactionsSummary';

class TransactionDiscountInformationBox implements ng.IController {
    public $inject = ['$localStorage'];
    public summary: IShopperStaffDiscountTransactionsSummary = null;
    public exportInProcess: boolean = false;

    public countryID: number;

    constructor(
        private $localStorage: ngStorage.StorageService
    ) {}

    public $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public exportCSV() {
        this.exportInProcess = true;
    }
}

angular.module('naut').component('transactionDiscountInformationBox', {
    template: require('./transaction-discount-information-box.component.html'),
    controller: TransactionDiscountInformationBox,
    controllerAs: 'ctrl',
    bindings: {
        summary: '<'
    }
});



// WEBPACK FOOTER //
// ./src/app.retailer/modules/discountForStaff/transaction-tab/transaction-with-discount-tab/transaction-discount-information-box/transaction-discount-information-box.component.ts